import {useKeycloak} from "@react-keycloak/web";
import {Button, Col, Form, Row} from "antd";
import {useEffect} from "react";
import {admin_welcome_img, xappHomeLogo} from '../../../AppImageConst';
import '../customerwelcome/style.scss'
import {useHistory} from "react-router-dom";

const AdminWelcomePage = () => {
    const redirectUri: string | undefined = process.env.REDIRECT_URI ? process.env.REDIRECT_URI : "http://localhost:3000/";
    const {keycloak} = useKeycloak();
    const adminHomePage = "workflow/admin/dashboard";
    let history = useHistory();
    useEffect(() => {
        if (keycloak && keycloak.authenticated) {
            history.push(adminHomePage)
        }
    }, []);

    const loginPage = (e: any) => {
        if (keycloak && !keycloak.authenticated) {
            keycloak.login({redirectUri: `${redirectUri}${adminHomePage}`});
        }
    }

    const logout = (e: any) => {
        if (keycloak.authenticated) {
            // keycloak.logout({redirectUri: `${redirectUri}workflow/admin/dashboard`})
            keycloak.logout({redirectUri: window.location.origin});
        }
    }
    return <>
        <div>
            <div className='welcome_screen'>
                <Row gutter={0} className='main-row'>
                    <Col lg={12} md={{span: 0}} sm={{span: 0}} hidden className='left-side-main-container'>
                        <Row gutter={0} className='main-row'>
                            <Col span={24}>
                                <div className="clip-path-img">
                                    <div className='clip-path-img-container text-center'>
                                        <img src={xappHomeLogo} className={'w-20'} alt="logo"/>
                                    </div>
                                </div>
                            </Col>
                            <Col span={24} md={24} sm={24} className='left-side-title-container'>
                                <h1 className='left-side-main-title'>NDB WEALTH</h1>
                                <h1 className='left-side-main-title'>Admin Portal</h1>
                                <div className="header_divider"></div>
                                <h2 className='left-side-sub-title'>- No paperwork, No stress - </h2>
                                {/*<h2 className='left-side-sub-title'>No stress</h2>*/}
                            </Col>
                        </Row>
                    </Col>
                    {/*TODO - change the discriptions .add suitable discriptions to admin*/}
                    <Col lg={12} className='right-side-col'>
                        <div className='right_side_container'>
                            <div>
                                <h1 className='main-header' style={{marginBottom: 20}}>Welcome to NDB Wealth</h1>
                                {/*<h5 className='sub-header' style={{marginBottom: 20}}>Path to your Wealth in few*/}
                                {/*    clicks</h5>*/}
                            </div>
                            <Row>

                                <Col xl={{span: 12, offset: 6}} lg={{span: 12, offset: 6}} md={{span: 12, offset: 6}}
                                     sm={24} xs={24} className='welcome_img'>
                                    <img src={admin_welcome_img} alt=""/>
                                </Col>
                                {/*<Col span={24} className='welcome_page_text_col'>*/}
                                {/*<span className='welcome_page_text-1'>*/}
                                {/*    New to INVESTING?*/}
                                {/*</span>*/}
                                {/*    <span className='welcome_page_text'>*/}
                                {/*    What do you hope to achieve in life? It’s your unique journey and we’ll partner with you to craft the plan. From preparing for retirement to funding a child’s education to saving for a major purchase, we’ll help you gain the clarity and confidence you need to take the next step.*/}
                                {/*</span>*/}

                                {/*</Col>*/}
                            </Row>
                            <Row gutter={16}>
                                <Col xl={{span: 12, offset: 6}} lg={{span: 12, offset: 6}} md={{span: 12, offset: 6}}
                                     sm={24} xs={24} className='sign-in-btn-container'>
                                    <Form.Item className='form-item-btn'>
                                        <Button className='custom-sign-in-btn-primary' type="ghost" onClick={loginPage}>
                                            Sign in
                                        </Button>
                                    </Form.Item>
                                </Col>

                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
            {keycloak.authenticated ? <Button onClick={logout}>Logout</Button> : <></>}
        </div>
    </>
}

export default AdminWelcomePage;
